// extracted by mini-css-extract-plugin
module.exports = {"offCanvas":"Navbar_offCanvas__zGTkt","storybook":"Navbar_storybook__Uj5Wo","fadeOut":"Navbar_fadeOut__UzCe8"};